// extracted by mini-css-extract-plugin
export var actionText = "_pb-4";
export var container = "_pb-0";
export var leftSection = "_pb-1";
export var rightSection = "_pb-2";
export var settingsButton = "_pb-6";
export var settingsIcon = "_pb-7";
export var shortcut = "_pb-5";
export var shortcutGroup = "_pb-3";